import { Component } from '@angular/core';

@Component({
  selector: 'app-processing-loader',
  templateUrl: './processing-loader.component.html',
  styleUrls: ['./processing-loader.component.scss'],
})
export class ProcessingLoaderComponent {}
